const initInterestedIn = (target, radios) => {
    const toggle = () => {
        const checked = radios.find((item) => item.checked).value === '1';
        target.style.display = checked ? null : 'none';
        target.querySelector('select').disabled = !checked;
    };

    radios.forEach((item) => item.addEventListener('change', toggle));

    toggle();
};

export default function enrolmentForm() {
    const target = document.getElementById('sq_form_field_wrapper_q299767_q7');
    if (target) {
        initInterestedIn(target, [
            ...document.querySelectorAll('[name="q299767:q6"]'),
        ]);
    }
}
